import {
  Alignment,
  Autoformat,
  AutoImage,
  AutoLink,
  Autosave,
  BlockQuote,
  Bold,
  Code,
  CodeBlock,
  Essentials,
  FileRepository,
  FontBackgroundColor,
  FontColor,
  FontFamily,
  FontSize,
  Heading,
  HorizontalLine,
  Image,
  ImageCaption,
  ImageInsert,
  ImageResize,
  ImageStyle,
  ImageTextAlternative,
  ImageToolbar,
  ImageUpload,
  Indent,
  IndentBlock,
  Italic,
  Link,
  LinkImage,
  List,
  ListProperties,
  MediaEmbed,
  Mention,
  PageBreak,
  Paragraph,
  PasteFromOffice,
  Plugin,
  RemoveFormat,
  SpecialCharacters,
  SpecialCharactersArrows,
  SpecialCharactersCurrency,
  SpecialCharactersEssentials,
  SpecialCharactersLatin,
  SpecialCharactersMathematical,
  SpecialCharactersText,
  Strikethrough,
  Subscript,
  Superscript,
  Table,
  TableCaption,
  TableCellProperties,
  TableColumnResize,
  TableProperties,
  TableToolbar,
  TextTransformation,
  Underline,
} from 'ckeditor5';
import {
  AIAssistant,
  Comments,
  MultiLevelList,
  PasteFromOfficeEnhanced,
  RealTimeCollaborativeComments,
  RealTimeCollaborativeTrackChanges,
  TrackChanges,
} from 'ckeditor5-premium-features';
import { QualioAWSTextAdapter } from '../plugins/AI/QualioAWSTextAdapter';
import { QualioClipboardPlugin } from '../plugins/Clipboard/QualioClipboardPlugin';
import { QualioCodeBlockPlugin } from '../plugins/CodeBlock/QualioCodeBlockPlugin';

export const getEditorAiPlugins = (): (typeof Plugin)[] => [
  AIAssistant,
  QualioAWSTextAdapter as unknown as typeof Plugin,
];

declare global {
  const Checkbox: any;
  const SectionList: any;
  const Smartlink: any;
  const FileUpload: any;
  const CKReusableContent: any;
}

export const CONTENT_EDITOR_PLUGINS: (typeof Plugin)[] = [
  Alignment,
  Autoformat,
  AutoImage,
  AutoLink,
  Autosave,
  Bold,
  BlockQuote,
  Code,
  CodeBlock,
  Comments,
  List,
  ListProperties,
  Essentials,
  FileRepository,
  FileUpload.QualioFileUpload,
  FontBackgroundColor,
  FontColor,
  FontFamily,
  FontSize,
  Heading,
  HorizontalLine,
  Image,
  ImageCaption,
  ImageInsert,
  ImageResize,
  ImageStyle,
  ImageTextAlternative,
  ImageToolbar,
  ImageUpload,
  Indent,
  IndentBlock,
  Italic,
  LinkImage,
  Link,
  MediaEmbed,
  Mention,
  MultiLevelList,
  Paragraph,
  PageBreak,
  PasteFromOfficeEnhanced,
  Checkbox.QualioCheckbox,
  SectionList.QualioSectionList,
  PasteFromOffice,
  QualioCodeBlockPlugin,
  RealTimeCollaborativeComments,
  RealTimeCollaborativeTrackChanges,
  RemoveFormat,
  SpecialCharacters,
  SpecialCharactersArrows,
  SpecialCharactersCurrency,
  SpecialCharactersEssentials,
  SpecialCharactersLatin,
  SpecialCharactersMathematical,
  SpecialCharactersText,
  Strikethrough,
  Subscript,
  Superscript,
  Table,
  TableCaption,
  TableCellProperties,
  TableProperties,
  TableToolbar,
  TextTransformation,
  TrackChanges,
  Underline,
  QualioClipboardPlugin,
  TableColumnResize,
  Smartlink.QualioSmartlink,
];

export const getContentEditorPlugins = () => {
  return CONTENT_EDITOR_PLUGINS;
};

export const getMentionPluginConfig = (companyId: number) => {
  return Smartlink.QualioSmartlink.getMentionConfig(
    companyId,
    process.env.REACT_APP_GLOBAL_SEARCH_SERVICE_URL,
  );
};
